module.exports = __webpack_public_path__ + "images/home/index/mobile/values-growth-screenshot-df939d43c05568c63f595028bae7d706.png";